import URL from './url'
import http from '@/utils/httpUtils'

export default {
  // 查询校区体温统计
  getTemperatureCampusStat(postData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_TEMPERATURE_GET_CAMPUS_STAT, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询校区(班主任)班级体温统计
  getTemperatureDeptStat(postData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_TEMPERATURE_GET_DEOT_STAT, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询正常(异常,未测量)体温统计学生明细
  getTemperatureDetail(postData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_TEMPERATURE_GET_DETAIL, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 获取体温范围
  getTemperatureRange(postData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_TEMPERATURE_GET_RANGE, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询某个学生测温日历
  queryUserTemperatureRecords(postData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_TEMPERATURE_GET_USER_RECORDS, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询学生温度月历
  getUserTemperatureCalendar(postData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_TEMPERATURE_GET_CALENDAR, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 体温学生数据报表导出
  exportTemperatureExcel(postData) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_TEMPERATURE_EXPORT_EXCEL, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 查询学生信息
  getTemperatureUserInfo(postData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_TEMPERATURE_GET_USERINFO, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // 保存人工复合记录
  saveTemperatureIndicator(postData) {
    return new Promise((resolve, reject) => {
      http
        .post(URL.API_TEMPERATURE_SAVE_INDICATOR, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  //  查询所有班级体温统计
  getCampusAndAllClassStat(postData) {
    return new Promise((resolve, reject) => {
      http
        .get(URL.API_TEMPERATURE_CAMPUS_CLASS_STAT, postData)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}
